import { rootRoute } from "@/routes";
import { VStack } from "@/shared/ui/primitives";
import { NavBar, Footer } from "@/shared/ui/composites";
import { createRoute } from "@tanstack/react-router";
import { HeroSection } from "./ui/HeroSection";
import { IntroSection } from "./ui/IntroSection";
import { MissionVisionSection } from "./ui/MissionVisionSection";
import { TimelineSection } from "./ui/TimelineSection";
import { FutureSection } from "./ui/FutureSection";

const Desktop = () => {
	return (
		<VStack className="w-full bg-bg-weak overflow-x-hidden">
			<NavBar />
			<VStack className="w-full max-w-[1200px] mx-auto gap-[60px] md:gap-[100px] pb-[60px] md:pb-[100px] px-[20px] md:px-[60px]">
				<HeroSection />
				<IntroSection />
				<MissionVisionSection />
				<TimelineSection />
				<FutureSection />
			</VStack>
			<Footer />
		</VStack>
	);
};

export const companyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/company",
	component: Desktop,
});
